import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca556954&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./my-assignments.scoped.css?vue&type=style&index=0&id=ca556954&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca556954",
  null
  
)

export default component.exports